import { action, computed, makeObservable, observable } from "mobx";
import _ from "lodash";
import { FormView } from "csi/form/View";
import { RightPaneComponent, RightPaneComponentAlwaysAllowed } from "csi/state/rightPane";
import Cache from "csi/store/Cache";
import { C8Node, cnl } from "csi/typings";

class TaskRightPaneComponent extends RightPaneComponent {
	@observable private _taskUrl: cnl;

	/** view cache */
	cache: Cache;

	/** indicates if editing task */
	@observable editViewDef: FormView;

	/** indicates if task is currently being edited */
	get isEditing(): boolean {
		return !!this.editViewDef;
	}

	/** selected task */
	get task(): C8Node {
		const { cache, _taskUrl } = this;
		return cache.get(_taskUrl);
	}

	/** selected task URL */
	get taskUrl(): string {
		return this._taskUrl;
	}

	/** set selected task */
	@action setTask(taskUrl: cnl): void {
		this._taskUrl = taskUrl;
		this.editViewDef = null;
	}

	constructor(cache: Cache) {
		super("ProcessDefinitionTask", {
			isAllowed: RightPaneComponentAlwaysAllowed,
			confirmLeaving: () => this.isEditing,
			view: "Camunda/component/ProcessDefinitionTask",
			viewWidth: 386,
		});

		this.cache = cache;
		makeObservable(this);
	}
}

export = TaskRightPaneComponent;
